import React, { Component, Fragment } from "react";
import api from "./services/api";
import { BrowserRouter, Switch, Route, Link } from "react-router-dom";
import "./styles.css";
import Login from "./entity/login";
import Home from "./entity/home";
import Configuration from "./entity/accreditation/configuration";
import Reports from "./entity/reports";
import Permission from "./entity/accreditation/permission";
import Company from "./entity/company/company-create";
import Solicitation from "./entity/accreditation/solicitation";
import Document from "./entity/configuration/document";
import CompanyType from "./entity/configuration/company-type";
import Sector from "./entity/configuration/sector";
import Instructor from "./entity/configuration/instructor";
import Function from "./entity/configuration/function";
import DocumentType from "./entity/configuration/document-type";
import CompanyDocuments from "./entity/company/documents";
import CompanyDocumentsPeriod from "./entity/company/documents-period";
import Detail from "./entity/accreditation/solicitation/detail";
import Contacts from "./entity/contacts";
import Employees from "./entity/employees/employees-create";
import ContactEdit from "./entity/contact-edit";
import EmployeesDocument from "./entity/employees/documents";
import EmployeesDocumentPeriodic from "./entity/employees/documents-periodic";
import CompanyEmployeesDocument from "./entity/accreditation/solicitation/employee";
import CompanyEdit from "./entity/accreditation/solicitation/company";
import IntegrationManager from "./entity/integration/manager";
import Notifications from "./entity/notifications";
import HomeBox from "./entity/homebox";
import LoginForgot from "./entity/login/forgot-password";
import ResetPassword from "./entity/login/reset-password";
import Users from "./entity/users";
import Moment from "react-moment";
import { version } from "../package.json";
import "moment-timezone";
import NotFound from "./components/NotFound/NotFound";

// Set the timezone for every instance.
//Moment.globalTimezone = "UTC";

class Routes extends Component {
  state = {
    menu: [],
    title: "",
    notifications: {},
    notification: {},
    userType: 0
  };

  componentDidMount() {
    if (
      window.location.pathname.length > 1 &&
      window.location.pathname != "/company" &&
      window.location.pathname != "/forgot-password" &&
      window.location.pathname.indexOf("/update-password") == -1
    ) {
      if (!localStorage.getItem("token")) {
        this.logout();
      } else {
        this.loadUserType();
        this.loadMenu();
        this.loadNotifications();

        this.setState({ title: "Home" });
      }
    }
  }

  logout = () => {
    localStorage.clear();
    window.location.href = window.location.origin;
  };

  loadMenu = async () => {
    this.setState({ load: true });
    const response = await api.get("/menu");
    const dadosMenu = response.data.data.filter(item => !item.MenuId);
    this.setState({ menu: dadosMenu, full_menu: response.data.data });
  };

  loadNotifications = async () => {
    const response = await api.get(
      `/notifications?UserId=${localStorage.getItem(
        "userId"
      )}&order_by=createdAt&visualized=false`
    );
    this.setState({ notifications: response.data.rows });
  };

  verifySubmeu = id => {
    return this.state.full_menu.filter(item => item.MenuId == id);
  };

  setVizualized = async e => {
    let not = this.state.notifications.filter(item => item.id == e.target.id);
    this.setState({ notification: not });
    await api.patch(`/notifications/${not[0].id}`, { visualized: true });
    this.loadNotifications();
    document.getElementById("btn_notification").click();
  };

  loadUserType
   = async e => {
    let response = await api.get(`/users/${localStorage.getItem("userId")}`);
    let user = response.data
    this.setState( { userType: user.UserTypeId } );
  }

  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={Login} />
          <div id="main-wrapper">
            <header className="topbar">
              <nav className="navbar top-navbar navbar-expand-md navbar-light">
                <div className="navbar-header">
                  <a className="navbar-brand" href="home">
                    <b>
                      <img
                        src={require("./entity/login/logo.fw.png")}
                        alt="homepage"
                        className="dark-logo"
                      />
                      <img
                        src={require("./entity/login/logo.fw.png")}
                        alt="homepage"
                        className="light-logo"
                      />
                    </b>
                    <span>
                      <img
                        src={require("./entity/login/icone.fw.png")}
                        alt="homepage"
                        className="dark-logo"
                      />
                      <img
                        src={require("./entity/login/icone.fw.png")}
                        className="light-logo"
                        alt="homepage"
                      />
                    </span>
                  </a>
                </div>

                <div className="navbar-collapse">
                  <ul className="navbar-nav mr-auto mt-md-0">
                    <li className="nav-item">
                      {" "}
                      <a
                        className="nav-link nav-toggler hidden-md-up text-muted waves-effect waves-dark"
                        href="javascript:void(0)"
                      >
                        <i className="mdi mdi-menu"></i>
                      </a>{" "}
                    </li>
                    <li className="nav-item">
                      {" "}
                      <a
                        className="nav-link sidebartoggler hidden-sm-down text-muted waves-effect waves-dark"
                        href="javascript:void(0)"
                      >
                        <i className="ti-menu"></i>
                      </a>{" "}
                    </li>
                  </ul>

                  <ul className="navbar-nav my-lg-0">
                    {localStorage.getItem("token") ? (
                      <li className="nav-item dropdown">
                        <a
                          className="nav-link dropdown-toggle text-muted waves-effect waves-dark"
                          href=""
                          id="2"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          {" "}
                          <i className="mdi mdi-email"></i>
                          <div
                            className={
                              this.state.notifications.length ? "notify" : null
                            }
                          >
                            <span className="heartbit"></span>
                            <span className="point"></span>
                          </div>
                        </a>
                        <div
                          className="dropdown-menu mailbox dropdown-menu-right scale-up"
                          aria-labelledby="2"
                        >
                          <ul>
                            <li>
                              <div className="drop-title">
                                Últimas notificações
                              </div>
                            </li>
                            <li>
                              <div className="message-center">
                                {this.state.notifications.length ? (
                                  this.state.notifications.map(item => {
                                    return (
                                      <a
                                        key={item.id}
                                        href="javascript:void(0)"
                                        id={item.id}
                                        onClick={this.setVizualized}
                                      >
                                        <div
                                          className="mail-contnet"
                                          id={item.id}
                                        >
                                          <h5 id={item.id}>
                                            <Moment
                                              format="DD/MM/YYYY HH:mm"
                                              id={item.id}
                                            >
                                              {item.createdAt}
                                            </Moment>
                                          </h5>
                                          <span
                                            className="text-primary"
                                            id={item.id}
                                          >
                                            {item.message.substr(0, 30)}...
                                          </span>
                                          <label
                                            className="label label-light-info"
                                            id={item.id}
                                          >
                                            Ler mensagem
                                          </label>
                                        </div>
                                      </a>
                                    );
                                  })
                                ) : (
                                  <div className="row">
                                    <div className="col-md-12 p-20 text-center">
                                      <label className="label label-light-info">
                                        Nenhuma nova notificação
                                      </label>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </li>
                            <li>
                              <a
                                className="nav-link text-center"
                                href="./homebox"
                              >
                                {" "}
                                <strong>Ver todas notificações</strong>{" "}
                                <i className="fa fa-angle-right"></i>{" "}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </li>
                    ) : null}

                    <li className="nav-item dropdown">
                      <a
                        className="nav-link dropdown-toggle text-muted waves-effect waves-dark"
                        href=""
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        {" "}
                        <i className="flag-icon flag-icon-br"></i>
                      </a>
                      <div className="dropdown-menu dropdown-menu-right scale-up">
                        <a className="dropdown-item" href="#">
                          <i className="flag-icon flag-icon-us"></i> USA
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>
              </nav>
            </header>

            <aside className="left-sidebar">
              <div className="scroll-sidebar">
                <div className="user-profile">
                  <div className="profile-text">
                    <span>
                      {localStorage.getItem("name")} -
                      {localStorage.getItem("businessName")}
                    </span>

                    {localStorage.getItem("UserTypeId") == 2 ? (
                      <a href="./reset-password">Alterar senha</a>
                    ) : null}
                  </div>
                </div>

                <nav className="sidebar-nav ">
                  <div className="novo">
                    <ul id="nav">
                      <li>
                        <a href="./">
                          <i className="mdi mdi-home"></i>
                          <span className="hide-menu">Home </span>
                        </a>
                      </li>
                      {this.state.menu.map((item, index) => {
                        return (
                          <li key={index}>
                            <a href={item.link} onClick={this.setTitle}>
                              <i className={item.icon}></i>
                              <span className="hide-menu">{item.name}</span>
                            </a>
                            {this.verifySubmeu(item.id).length > 0
                              ? this.verifySubmeu(item.id).map(
                                  (item1, index1) => {
                                    return (
                                      <ul
                                        aria-expanded="false"
                                        className="collapse"
                                        key={index1}
                                      >
                                        <li>
                                          <Link
                                            to={
                                              item1.link != "/"
                                                ? item1.link
                                                : "javascript:void(0)"
                                            }
                                            onClick={this.setTitle}
                                          >
                                            <i className={item1.icon}></i>
                                            {item1.name}
                                          </Link>
                                          {this.verifySubmeu(item1.id).length >
                                          0
                                            ? this.verifySubmeu(item1.id).map(
                                                (item2, index2) => {
                                                  return (
                                                    <ul
                                                      aria-expanded="false"
                                                      className="collapse"
                                                      key={index2}
                                                    >
                                                      <li>
                                                        <Link
                                                          to={item2.link}
                                                          onClick={
                                                            this.setTitle
                                                          }
                                                        >
                                                          <i
                                                            className={
                                                              item2.icon
                                                            }
                                                          ></i>
                                                          {item2.name}
                                                        </Link>
                                                      </li>
                                                    </ul>
                                                  );
                                                }
                                              )
                                            : null}
                                        </li>
                                      </ul>
                                    );
                                  }
                                )
                              : null}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </nav>
              </div>

              <div className="sidebar-footer">
                <nav className="sidebar-nav text-center">
                  {localStorage.getItem("token") ? (
                    <span className="btn-logout" onClick={this.logout}>
                      <span>
                        <i className="fa fa-sign-out"></i> Logout
                      </span>
                    </span>
                  ) : (
                    <span className="btn-logout" onClick={this.logout}>
                      <span>
                        <i className="fa fa-arrow-left"></i> Cancelar
                      </span>
                    </span>
                  )}


                  <small className="font-weight-bold d-block p-10">
                    DP World - <b>V {version}</b> <br/>
                    <a href="https://cdi.dpworldsantos.com/DPWS_Aviso_de_Privacidade.pdf" style={{padding:0, textAlign:"center", color:"white", width:'100%', float:'none', fontSize:12, textDecoration:'underline' }} target="_blank">Politica de privacidade DP World</a>
                  </small>
                </nav>
              </div>
            </aside>

            <div className="page-wrapper">
              <div className="container-fluid">
                <Route path="/home" component={Home} />
                <Route path="/company" component={Company} />
                <Route path="/companies-edit/:id" component={CompanyEdit} />
                <Route path="/notifications" component={Notifications} />
                <Route path="/forgot-password/" component={LoginForgot} />
                <Route path="/update-password/:hash" component={LoginForgot} />
                <Route path="/reset-password" component={ResetPassword} />
                { this.state.userType == 1 ? (
                  <Fragment>
                    <Route path="/reports" component={Reports} />
                    <Route path="/documents" component={Document} />
                    <Route path="/documents-types" component={DocumentType} />
                    <Route path="/sectors" component={Sector} />
                    <Route path="/functions" component={Function} />
                    <Route path="/companies-types" component={CompanyType} />
                    <Route path="/instructors" component={Instructor} />
                    <Route path="/solicitations" component={Solicitation} />
                    <Route path="/companies/:id" component={Detail} />
                    <Route path="/contact-edit/:userId/:id" component={ContactEdit} />
                    <Route path="/companies-id/:companyid/employee-documents/:id" component={CompanyEmployeesDocument} />
                    <Route path="/permissions" component={Permission} />
                    <Route path="/configurations" component={Configuration} />
                    <Route path="/integrations-manger" component={IntegrationManager} />
                    <Route path="/users" component={Users} />
                    <Route path="/homebox" component={HomeBox} />
                  </Fragment>
                ) : this.state.userType == 2 ? (
                  <Fragment>
                    <Route path="/documents-company" component={CompanyDocuments} />
                    <Route path="/employees" component={Employees} />
                    <Route path="/employee/:id" component={EmployeesDocument} />
                    <Route path="/contacts" component={Contacts} />
                    <Route path="/contact-edit/:userId/:id" component={ContactEdit} />
                    <Route path="/employee-periodic/:id" component={EmployeesDocumentPeriodic} />
                    <Route path="/documents-periodic" component={CompanyDocumentsPeriod} />
                  </Fragment>
                ) : (
                  <Fragment>
                    <Route path="/reports" component={Reports} />
                    <Route path="/solicitations" component={Solicitation} />
                    <Route path="/companies/:id" component={Detail} />
                    <Route path="/contact-edit/:userId/:id" component={ContactEdit} />
                    <Route path="/companies-id/:companyid/employee-documents/:id" component={CompanyEmployeesDocument} />
                    <Route path="/integrations-manger" component={IntegrationManager} />
                  </Fragment>
                ) }
                {/* <Route component={NotFound} /> */}
              </div>
            </div>
            
            <div
              id="btn_notification"
              data-toggle="modal"
              data-target=".modal-list-notification"
            ></div>
            <div
              className="modal fade modal-list-notification"
              data-backdrop="static"
              role="dialog"
              aria-labelledby="myLargeModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="myLargeModalLabel">
                      Notificação
                    </h5>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-hidden="true"
                    >
                      ×
                    </button>
                  </div>
                  <div className="modal-body">
                    {this.state.notification.length ? (
                      <div>
                        <b>Data da notificação:</b>{" "}
                        <Moment format="DD/MM/YYYY HH:mm">
                          {this.state.notification[0].createdAt}
                        </Moment>
                        <br />
                        <b>Mensagem:</b> {this.state.notification[0].message}
                      </div>
                    ) : null}
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      id="closeModalIntegrations"
                      className="col-md-2 btn btn-secondary btn-rounded waves-effect"
                      data-dismiss="modal"
                    >
                      Fechar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Switch>               
      </BrowserRouter>
    );
  }
}

export default Routes;
